export {
  formatPostDate,
  getPlainExcerpt,
  getPostTypeLabel,
} from "../Members/memberUtils";

export const FOUR_YEAR_PAGE_SIZE = 2;

export const FOUR_YEAR_FILTER = {
  authorIds: [],
  educationOnly: false,
  searchString: "4 Year Journey",
  applySearchStringTo: {
    title: false,
    content: false,
    excerpt: false,
    tags: true,
  },
};

/** Prod Google Sheet embed / mobile link URL. */
export const MODEL_PORTFOLIO_SHEET_URL =
  "https://docs.google.com/spreadsheets/d/1VYWi-e2O9tX2gys8fyZI57i3ePfy6C9EhR1K8FFwLu8/edit#gid=0&range=A2:G35?widget=true&headers=false";
